import {
  Grid,
  GridColumn,
  GridRow,
  LazyLoader,
  OverviewIllustration,
  PdfIcon,
  SubjectIllustration,
} from '@bp/ui-components';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { EvaluateCurrentDeputateStats } from '../../../../../components/Deputate/EvalutateDeputateStats/EvaluateCurrentDeputateStats';
import { IconMenu } from '../../../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../../../components/Page/Page';
import { useTimetableBlockByUuid } from '../../../../../components/TimetableBlock/hooks/useTimetableBlocks';
import { usePermissionChecker } from '../../../../../hooks/usePermissionChecker';

export const DeputateEvaluateCurrentPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = usePermissionChecker();

  const { blockUuid } = useParams();
  const showAll = blockUuid === t('routes.deputate.evaluate.all.slug');

  const { timetableBlock } = useTimetableBlockByUuid(blockUuid, { pause: showAll });

  return (
    <Page
      isForbidden={!permissions?.canReadDeputate()}
      title={t('deputate.current')}
      subheadline={showAll ? t('routes.deputate.evaluate.all.title') : timetableBlock?.name}
    >
      <Grid>
        <GridRow spacingBottom={'m'}>
          <GridColumn width={6}>
            <IconMenu variant='tabs' hasMarginBottom columns={3}>
              <IconMenuItem
                label={`${t('deputate.menuItems.overview')}`}
                icon={<OverviewIllustration />}
                bubbleType={4}
                onClick={() => navigate('')}
                active={blockUuid ? location.pathname.endsWith(blockUuid) : false}
              />
              <IconMenuItem
                label={`${t('deputate.menuItems.subject')}`}
                icon={<SubjectIllustration />}
                bubbleType={5}
                onClick={() => navigate(t('routes.deputate.evaluate.bySubject.slug'))}
                active={location.pathname.endsWith(t('routes.deputate.evaluate.bySubject.slug'))}
              />
              <IconMenuItem
                label={t('pdf.title', { count: 2 })}
                icon={<PdfIcon />}
                bubbleType={10}
                onClick={() => navigate(t('routes.deputate.evaluate.reports.slug'))}
                active={location.pathname.endsWith(t('routes.deputate.evaluate.reports.slug'))}
              />
            </IconMenu>
          </GridColumn>
          <GridColumn width={6}>
            <EvaluateCurrentDeputateStats />
          </GridColumn>
        </GridRow>
      </Grid>
      <Suspense fallback={<LazyLoader transparent forceHeight='50vh' />}>
        <Outlet />
      </Suspense>
    </Page>
  );
};
